import { REVIEW_ENTRY_STATUSES } from '@/lib/constants/reviewEntries'

export const REVIEW_ENTRIES = {
  NEVER: 'Never',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  DATE: 'Date',
  PERFORMED_BY: 'Performed by',
  NOTES: 'Notes',
  STATUS: 'Status',
  STATUSES: {
    [REVIEW_ENTRY_STATUSES.SUCCESS]: 'Ok',
    [REVIEW_ENTRY_STATUSES.WARNING]: 'With warnings',
    [REVIEW_ENTRY_STATUSES.FAILED]: 'Failed',
  },
  SAVED: 'Entry logged',
  ATTACH_FILE: 'Attach file',
  REMOVE_FILE: 'Remove file',
  OPEN_FILE_FAILED: 'Could not open the file',
  REVIEW: {
    LABEL: 'Last review',
    HISTORY: 'Review history',
    COUNT: (count: number) => (count === 1 ? '1 review' : `${count} reviews`),
    LOG: 'Log a review',
    EMPTY: 'No reviews logged',
  },
  MAINTENANCE: {
    LABEL: 'Last maintenance',
    HISTORY: 'Maintenance history',
    COUNT: (count: number) => (count === 1 ? '1 entry' : `${count} entries`),
    LOG: 'Log a maintenance',
    EMPTY: 'No maintenance logged',
  },
}
